<template>
  <d-row>
    <!-- Editor -->
    <d-col lg="9" class="mb-4">
      <d-row class="mb-4">
        <d-col cols="12">
          <ticket-chat :comments="ticket.comments"/>
        </d-col>
      </d-row>
      <d-row>
        <d-col cols="12">
          <d-card class="card-small blog-comments">
            <!-- Card Header -->
            <d-card-header class="border-bottom">
              <h6 class="m-0">Responder</h6>
            </d-card-header>

            <d-card-body>
              <editor-ticket-chat :ticket-id="ticket.id"></editor-ticket-chat>
            </d-card-body>
          </d-card>
        </d-col>
      </d-row>
    </d-col>

    <!-- Sidebar Widgets -->
    <d-col lg="3" md="12">
      <sidebar-actions :model="ticket" />
    </d-col>
    <confirmation-modal
      :cancel="close"
      :confirm="callback"
      :title="confirmation[type].title"
      :message="confirmation[type].message"/>
  </d-row>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import TicketService from '_services/rest/modules/ticket';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import EditorTicketChat from './EditorTicketChat.vue';
import SidebarActions from './SidebarActions.vue';
import TicketChat from './TicketChat.vue';
import { MODEL, _LOAD_MODEL_, OPTIONS_CONFIRMATION_MODAL, _OPEN_CONFIRMATION_, _RESET_MODEL_, _SAVE_MODEL_ } from './TicketModel';

export default {
  name: 'ticket-comments-page',
  components: {
    TicketChat,
    SidebarActions,
    EditorTicketChat,
    ConfirmationModal,
  },
  data() {
    return {
      ticket: { ...MODEL },
      type: 'status',
      message: null,
      object: null,
      confirmation: OPTIONS_CONFIRMATION_MODAL,
    };
  },
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
      'updateTicket',
    ]),
    close() {
      this.setToggle({ type: 'confirm_modal', bool: false });
      Events.$emit(_RESET_MODEL_);
    },
    callback() {
      const { callback } = this.confirmation[this.type];
      this[callback]();
    },
    update() {
      this.setToggle({ type: 'confirm_modal', bool: false });
      return this.updateTicket(this.object)
        .then(() => {
          this.activeAlert({ message: this.message, theme: 'success' });
        });
    },
    deleteFile() {
      this.setToggle({ type: 'confirm_modal', bool: false });
      TicketService.deleteFile(this.object.id)
        .then(() => {
          Events.$emit(_SAVE_MODEL_);
          this.activeAlert({ message: this.message, theme: 'success' });
        });
    },
  },
  mounted() {
    Events.$on(_LOAD_MODEL_, ticketEdit => {
      this.ticket = ticketEdit;
    });
    Events.$on(_OPEN_CONFIRMATION_, ({ object, type, message }) => {
      this.type = type;
      this.object = object;
      this.message = message;
      this.setToggle({ type: 'confirm_modal', bool: true });
    });
  },
};
</script>
